// Mock dati per click/storico click.

export const buildStoricoClicksMock = () => [
  {
    dataOraClick: "2026-03-01T10:20:00Z",
    linkClick: "https://vendor.test/prodotto-1",
    browser: "Chrome",
  },
  {
    dataOraClick: "2026-03-02T12:05:00Z",
    linkClick: "https://vendor.test/prodotto-2",
    browser: "Firefox",
  },
  {
    dataOraClick: "2026-03-03T15:45:00Z",
    linkClick: "https://vendor.test/prodotto-3",
    browser: "Edge",
  },
];

